// extracted by mini-css-extract-plugin
export default {"no-results":"no-results--sOE_c","text":"text--2Ebr0"};